import { Link } from "react-router-dom";
import { Facebook } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { NAV } from "./Header";

export const Footer = () => {
  const c = useContent();
  const s = c?.settings || {};
  return (
    <footer className="bg-[#1A1A1A] text-[#E5E0D8] px-6 md:px-16 lg:px-24 pt-20 pb-10 mt-24" data-testid="site-footer">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="font-serif-display text-4xl text-[#FDFBF7]">SømSignature</p>
          <p className="text-[0.65rem] tracking-[0.3em] uppercase text-[#C4A47C] mt-2">by Liisa Lipasina</p>
          <p className="mt-6 text-sm leading-relaxed max-w-sm text-[#D6C9BE]">{s.tagline}</p>
          <a href="https://www.facebook.com/somrombergen" target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-3 px-6 py-3 border border-[#C4A47C] text-[#FDFBF7] text-sm hover:bg-[#C4A47C] hover:text-[#1A1A1A] transition-colors duration-300" data-testid="footer-facebook-btn">
            <Facebook className="w-4 h-4" strokeWidth={1.5} />Følg oss på Facebook
          </a>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow !text-[#C4A47C] mb-5">Sider</p>
          <ul className="space-y-3 text-sm">
            {NAV.map((n) => <li key={n.to}><Link to={n.to} className="hover:text-[#C4A47C] transition-colors">{n.label}</Link></li>)}
            <li><Link to="/personvern" className="hover:text-[#C4A47C] transition-colors" data-testid="footer-privacy-link">Personvern</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4 text-sm space-y-2" data-testid="footer-contact">
          <p className="eyebrow !text-[#C4A47C] mb-5">Atelier</p>
          <p>{s.address}</p>
          {s.phone && <p>Tlf: {s.phone}</p>}
          {s.email && <p>{s.email}</p>}
          <div className="pt-3 space-y-1">
            {(s.hours || []).map((h) => <p key={h.day} className="flex justify-between max-w-xs"><span>{h.day}</span><span>{h.time}</span></p>)}
          </div>
        </div>
      </div>
      <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#8a857d]">
        <p>© {new Date().getFullYear()} SømSignature by Liisa Lipasina</p>
        <Link to="/admin" className="hover:text-[#C4A47C]" data-testid="footer-admin-link">Admin</Link>
      </div>
    </footer>
  );
};
